import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormatAbsolutePipe } from '@libs/shared/ui';

@Component({
  selector: 'ui-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    FormatAbsolutePipe,
  ],
})
export class ErrorComponent {
}
